import * as stylex from '@stylexjs/stylex';
import { forwardRef } from 'react';
import { Icon, type IconProps } from '../IconShell';
import { iconsStyles } from '../styles';
export const MailVan = forwardRef<SVGSVGElement, Partial<IconProps>>(function MailVan({
  styles,
  ...props
}, ref) {
  return <Icon title="Mail Van" description="Picture of a mail delivery van" ref={ref} {...stylex.props(styles)} viewBox="0 0 42 35" {...props}>
        <path {...stylex.props(iconsStyles.lightElement)} d="M2 14.3 5 13s1.7-5 3.6-9.2A5.3 5.3 0 0 1 13.1.6C18 .2 28-.4 36.8.4c2.5.2 4.5 2.1 4.8 4.6a94.6 94.6 0 0 1-.1 20c-.3 2.4-2 4.2-4.4 4.4-3 .2-8 .5-16.1.5-8.7 0-13.9-.3-16.7-.6-2-.2-3.7-1.6-4-3.6a29.8 29.8 0 0 1 .3-9.8c.2-.7.7-1.2 1.3-1.6Z" />
        <path {...stylex.props(iconsStyles.darkElement)} d="M12 34.9a6 6 0 1 0 0-12 6 6 0 0 0 0 12ZM31 34.9a6 6 0 1 0 0-12 6 6 0 0 0 0 12ZM11.6 4.9c.3-.7 1-1.1 1.7-1.2a18 18 0 0 1 5.6 0c.7 0 1.2.6 1.3 1.3a24 24 0 0 1 0 6.4c0 .9-.8 1.5-1.7 1.6-3.1.2-6 .1-7.5 0-.8 0-1.4-.8-1.3-1.6A21 21 0 0 1 11.6 5Z" />
      </Icon>;
});